import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseExpressDelivery() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getExpressList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Logestic_ExpressManage?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getExpressById = (expressID, callback) => {
    MyAxios.get(`Admin_Logestic_ExpressManage/${expressID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const getLogesticsPlatforms = (callback) => {
    MyAxios.get(`Admin_Logestic_ExpressManage/logestics`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOrderStates = (callback) => {
    MyAxios.get(`Admin_Logestic_ExpressManage/orderstate`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getLogesticsDriver = (callback) => {
    MyAxios.get(`Admin_Logestic_DriverManage`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const createAlopeykOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_ExpressManage/createorder`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const updateAlopeykOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_ExpressManage/updateorder`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const updateAllAlopeykOrder = (callback) => {
    MyAxios.post(`Admin_Logestic_ExpressManage/updateorders`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data);
        }
      }
    );
  };

  const cancelAlopeykOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_ExpressManage/cancelorder`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getExpressList,
    getExpressById,
    getLogesticsPlatforms,
    getOrderStates,
    getLogesticsDriver,
    createAlopeykOrder,
    updateAlopeykOrder,
    cancelAlopeykOrder,
    updateAllAlopeykOrder,
  };
}
